﻿

(function ($, document) {
    $(document).ready(function () {
        $(document).on('change', '.js-cellar-header-checkbox input[type=checkbox]', function (e) {
            if ($(this).is(':checked')) {
                $('.js-cellar-line-checkbox input[type=checkbox]').prop('checked', true);
            } else {
                $('.js-cellar-line-checkbox input[type=checkbox]').prop('checked', false);
            }
        });

        $(document).on('change', '.js-cellar-header-dropdown', function (e) {
            var cellarCode = $(this).val();
            $('.js-cellar-line-checkbox input[type=checkbox]:checked')
                .parents('tr')
                .find('.js-cellar-line-dropdown')
                .val(cellarCode)
                ;
        });
    });
})(jQuery, document);